module.exports = __webpack_public_path__ + "img/2.7750b6a.jpg";